import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=3c6aa323&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6aa323')) {
      api.createRecord('3c6aa323', component.options)
    } else {
      api.reload('3c6aa323', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=3c6aa323&", function () {
      api.rerender('3c6aa323', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/utils/tabs/Tabs.vue"
export default component.exports